import Login from './shared/login/Login';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import CurrentBalanceTile from './resui/payments/components/CurrentBalanceTile';
import ResUI from './resui/ResUI';
import { OnBoarding } from './pmui/onboarding/OnBoarding';
import Activate from './resui/activatation/ActivateAccount';
import CompleteRegistration from './resui/activatation/CompleteRegistration';
import PmUI from './pmui/PmUI';
import { Residentpage } from './shared/signup/Residentpage';
import { PMPage } from './shared/signup/PMPage';
import { ForgetPass } from './shared/signup/ForgetPass';
import { Resend } from './shared/signup/Resend';
import { ChangePassword } from './shared/signup/ChangePassword';
import { SignUp } from './shared/signup/SignUp';
import { ApplicationDashboard } from './pmui/onboarding/ApplicationDashboard';
import TermsAndConditions from './resui/terms';
import UserLogin from './resui/activatation/UserLogin';
import AdminPortal from './adminPortal/adminPortal';
import MakePayment from './shared/MakePayment/MakePayment';
import { SpecialCodePage } from './shared/signup/SpecialCode';
import Applicant from './resui/applications/Applicant';
import PrivacyPolicy from './shared/privacypolicy';
import QuickPayment from './resui/quickpayments/QuickPayment';
import CacheBuster from 'react-cache-buster';
import OwnerUI from './ownerui/OwnerUI';
import CurrentlyUnderMaintenance from './shared/CurrentlyUnderMaintenance';
import { OwnerPage } from './shared/signup/OwnerPage';
import useHealthCheck from './useHealthcheckHook';
import PricingV2 from './pricing/PricingV2';

export default function App() {
  const isProductionEnv = process.env.NODE_ENV === 'production';
  const localUiVersion = process.env.REACT_APP_VERSION || 'dev';
  const { isInMaintenanceMode } = useHealthCheck(); //invoke heathcheck process

  return (
    //temporarily disabling cachebuster for now. It forced some browsers to go into an infinte loop.
    <CacheBuster
      currentVersion={localUiVersion}
      isEnabled={isProductionEnv}
      isVerboseMode={!isProductionEnv} //If true, the library writes verbose logs to console.
      metaFileDirectory={'.'} //If public assets are hosted somewhere other than root on your server.
    >
      {isInMaintenanceMode ? (
        <CurrentlyUnderMaintenance />
      ) : (
        <div>
          <BrowserRouter>
            <Switch>
              <Route exact={true} path="/" component={Login} />
              <Route path="/login" component={Login} />
              <Route path="/balancedetails" component={CurrentBalanceTile} />
              <Route path="/activate" component={Activate} />
              <Route path="/completeregistration" component={CompleteRegistration} />
              <Route path="/userlogin" component={UserLogin} />
              <Route path="/resui" component={ResUI} />
              <Route path="/pmui" component={PmUI} />
              <Route path="/ownerui" component={OwnerUI} />
              <Route path="/signup" component={SignUp} />
              <Route path="/code" component={SpecialCodePage} />
              <Route path="/residentpage" component={Residentpage} />
              <Route path="/owner" component={OwnerPage} />
              <Route path="/PMpage" component={PMPage} />
              <Route path="/forgetpassword" component={ForgetPass} />
              <Route path="/resend" component={Resend} />
              <Route path="/onboarding" component={OnBoarding} />
              <Route path="/applicationdashboard" component={ApplicationDashboard} />
              <Route path="/pricing" component={PricingV2} />
              <Route path="/changepassword/:token?" component={ChangePassword} />
              <Route path={`/terms`} component={TermsAndConditions} />
              <Route path={`/makepayment`} component={MakePayment} />
              <Route path="/apply" component={Applicant} />
              <Route path={`/privacypolicy`} component={PrivacyPolicy} />
              <Route path={`/quickpay/:organization_uuid`} component={QuickPayment} />
              <Route path={`/adminportal`} component={AdminPortal} />
            </Switch>
          </BrowserRouter>
        </div>
      )}
    </CacheBuster>
  );
}
